import React, { useEffect } from "react";
import ApplicationForm from "./form/ApplicationForm";
import havran from "../preschool-page/images/havran.jpeg";
import stan from "../preschool-page/images/stan.jpeg";
import "./application-page.scss";
import { CURRENT_YEAR, IS_REGISTRATION_CLOSED } from "../../../constants";

export const ApplicationPage = () => {
  useEffect(() => {
    document.title =
      `Přihláška | Letní dětský tábor Osada Na Havraní zátoce ${CURRENT_YEAR}`;
  }, []);

  if (IS_REGISTRATION_CLOSED) {
    return (
      <div className="application-page page">
        <h2 className="page__title">Předběžná přihláška</h2>
        <div className="application-page__capacity-reached">
          <img
            src={stan}
            alt="Malovaný obrázek havrana"
            className="application-page__capacity-reached__image"
          />
          <p className="application-page__capacity-reached__text">
            Tábor je již plně obsazen.
          </p>
        </div>
        {/* <p className="application-page__additional-information">
                *Po odeslání předběžné přihlášky Vás budeme kontaktovat a
                následně zašleme přihlášku závaznou.
            </p> */}
        {/* <EmailContactForm /> */}

        {/* <section className="form-section">
        <ApplicationForm />
      </section> */}
      </div>
    );
  }

  return (
    <div className="application-page page">
      <h2 className="page__title">Předběžná přihláška</h2>
      {/* <div className="application-page__capacity-reached">
        <img
          src={stan}
          alt="Malovaný obrázek havrana"
          className="application-page__capacity-reached__image"
        />
        <p className="application-page__capacity-reached__text">
          Tábor je již plně obsazen.
        </p>
      </div> */}
      {/* <p className="application-page__additional-information">
                *Po odeslání předběžné přihlášky Vás budeme kontaktovat a
                následně zašleme přihlášku závaznou.
            </p> */}
      {/* <EmailContactForm /> */}

      <section className="form-section">
        <ApplicationForm />
      </section>
    </div>
  );
};
export default ApplicationPage;
